import { FC, ComponentProps } from 'react';
import styleToCss from 'style-object-to-css-string';
import styled from 'styled-components';
import { Box } from '@altermaind/web/ui';

type Props = ComponentProps<typeof Box> & {};

export const StyledDatePickerWrapper = styled(Box)<Props>(({ theme }) => {
  const iconSize = theme?.sizes?.xs || 16;
  return `
  & div[data-testid="DateContainer"] div[data-testid="DatepickerLeftChevron"],
  & div[data-testid="DateContainer"] div[data-testid="DatepickerRightChevron"] {
		${styleToCss({
      display: 'flex',
    })}
    & > img {
      ${styleToCss({
        width: iconSize,
      })}
    }
  }
`;
}) as FC<Props>;

StyledDatePickerWrapper.defaultProps = {};
